import { Icon } from '@iconify/react/dist/iconify.js'
import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { api } from '../../helper/api.interceptor'
import Swal from "sweetalert2";
import { styled } from '@mui/material/styles';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';


const Android12Switch = styled(Switch)(({ theme }) => ({
    padding: 8,
    '& .MuiSwitch-track': {
        borderRadius: 22 / 2,
        '&::before, &::after': {
            content: '""',
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            width: 16,
            height: 16,
        },
        '&::before': {
            backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
                theme.palette.getContrastText(theme.palette.primary.main),
            )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
            left: 12,
        },
        '&::after': {
            backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
                theme.palette.getContrastText(theme.palette.primary.main),
            )}" d="M19,13H5V11H19V13Z" /></svg>')`,
            right: 12,
        },
    },
    '& .MuiSwitch-thumb': {
        boxShadow: 'none',
        width: 16,
        height: 16,
        margin: 2,
    },
}));

const LatestRegisteredOne = () => {
    const [farms, setFarms] = useState([]);

    const fetchFarmerFarmDataInit = async () => {
        try {
            const data = await api.fetchFarmerFarm();
            setFarms(data || []);
        } catch (error) {
            console.error('Error fetching farms:', error);
        }
    };
    useEffect(() => {
        fetchFarmerFarmDataInit();
    }, []);


    const handleDeleteClick = async (id, user_id) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel",
        });

        if (result.isConfirmed) {
            try {
                api.fetchFarmDelete(id, user_id)
                    .then((data) => {
                        if (data && data.status_code && data.status_code === 200) {
                            Swal.fire("Deleted!", "The job opening has been deleted.", "success");
                            fetchFarmerFarmDataInit();
                        } else {
                            Swal.fire("Error!", "Failed to delete the job opening.", "error");
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        Swal.fire("Error!", err.message, "error");
                    });
            } catch (error) {
                Swal.fire("Error!", "There was an issue deleting the job. Please try again.", "error");
            }
        }
    };


    const handleStatusChange = async (id, currentStatus) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Approve it!",
            cancelButtonText: "Cancel",
        });

        if (result.isConfirmed) {
            try {
                const newStatus = currentStatus === "Approved" ? "Pending" : "Approved";
                const response = await api.approveFarmStatus(id, newStatus);

                if (response && response.status_code === 200) {
                    Swal.fire("Success", "Status updated successfully", "success");
                    setFarms((prevFarms) =>
                        prevFarms.map((farm) =>
                            farm._id === id ? { ...farm, status: newStatus } : farm
                        )
                    );
                } else {
                    Swal.fire("Error", "Failed to change status", "error");
                }
            } catch (error) {
                console.error("Error changing status:", error);
                Swal.fire("Error", error.message || "Failed to update status", "error");
            }
        }
    };


    const [latestwholesaler, setlatestwholesaler] = useState([]);

    const fetchwholesaler = async () => {
        try {
            const data = await api.fetchAllWholesaler();
            setlatestwholesaler(data || []);
        } catch (error) {
            console.error("Error fetching products:", error);
        }
    };

    useEffect(() => {
        fetchwholesaler();
    }, []);

    const handleDeletewholesalerClick = async (id) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel",
        });

        if (result.isConfirmed) {
            try {
                api.wholesalerDelete(id)
                    .then((data) => {
                        if (data && data.status_code && data.status_code === 200) {
                            Swal.fire("Deleted!", "The job opening has been deleted.", "success");
                            fetchwholesaler();
                        } else {
                            Swal.fire("Error!", "Failed to delete the job opening.", "error");
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        Swal.fire("Error!", err.message, "error");
                    });
            } catch (error) {
                Swal.fire("Error!", "There was an issue deleting the job. Please try again.", "error");
            }
        }
    };


    return (
        <div className="col-xxl-9 col-xl-12">
            <div className="card h-100">
                <div className="card-body p-24">
                    <div className="d-flex flex-wrap align-items-center gap-1 justify-content-between mb-16">
                        <ul
                            className="nav border-gradient-tab nav-pills mb-0"
                            id="pills-tab"
                            role="tablist"
                        >
                            <li className="nav-item" role="presentation">
                                <button
                                    className="nav-link d-flex align-items-center active"
                                    id="pills-to-do-list-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-to-do-list"
                                    type="button"
                                    role="tab"
                                    aria-controls="pills-to-do-list"
                                    aria-selected="true"
                                >
                                    Latest Farms
                                </button>

                            </li>
                            <li className="nav-item" role="presentation">
                                <button
                                    className="nav-link d-flex align-items-center"
                                    id="pills-recent-leads-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-recent-leads"
                                    type="button"
                                    role="tab"
                                    aria-controls="pills-recent-leads"
                                    aria-selected="false"
                                    tabIndex={-1}
                                >
                                    Latest wholesaler
                                </button>
                            </li>
                        </ul>
                        <Link
                            to="/farms"
                            className="text-primary-600 hover-text-primary d-flex align-items-center gap-1"
                        >
                            View All
                            <Icon
                                icon="solar:alt-arrow-right-linear"
                                className="icon"
                            />
                        </Link>
                    </div>
                    <div className="tab-content" id="pills-tabContent">
                        <div
                            className="tab-pane fade show active"
                            id="pills-to-do-list"
                            role="tabpanel"
                            aria-labelledby="pills-to-do-list-tab"
                            tabIndex={0}
                        >
                            <div className="table-responsive scroll-sm">
                                <table className="table bordered-table sm-table mb-0">
                                    <thead>
                                        <tr>
                                            <th scope="col">Images</th>
                                            <th scope="col">Name</th>
                                            <th scope="col">Date</th>
                                            <th scope="col">Country</th>
                                            <th scope="col">City</th>
                                            <th scope="col">Status</th>
                                            <th scope="col">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {farms.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                                            .slice(0, 5)
                                            .map((farm) => (
                                                <tr key={farm._id}>

                                                    <td>
                                                        <img
                                                            src={farm.images?.[0] || '/assets/images/farmerimg.jpg'}
                                                            alt={farm.name || 'No Image'}
                                                            className="img-fluid radius-8"
                                                            style={{ width: '50px', height: '50px', objectFit: 'cover' }}
                                                        />
                                                    </td>
                                                    <td>{farm.name || 'No Name Available'}</td>
                                                    <td>{farm.createdAt ? new Date(farm.createdAt).toLocaleDateString() : 'No Date' || 'No Date Available'}</td>
                                                    <td>{farm.city || 'No City Provided'}</td>
                                                    <td>{farm.country || 'No Country Provided'}</td>
                                                    <td>
                                                        <FormGroup>
                                                            <FormControlLabel
                                                                control={
                                                                    <Android12Switch
                                                                        checked={farm.status === "Approved"}
                                                                        onChange={() => handleStatusChange(farm._id, farm.status)}
                                                                    />
                                                                }
                                                                label={farm.status || "Pending"}
                                                            />
                                                        </FormGroup>
                                                    </td>
                                                    <td>
                                                        <Link
                                                            to={`/farms/details/${farm._id}`}
                                                            className="w-32-px h-32-px me-8 bg-primary-light text-primary-600 rounded-circle d-inline-flex align-items-center justify-content-center"
                                                        >
                                                            <Icon icon="iconamoon:eye-light" />
                                                        </Link>
                                                        <Link
                                                            to={"/farmer/edit/" + farm._id}
                                                            onClick={() => localStorage.setItem("selectedFarmerId", farm._id)}
                                                            className="w-32-px h-32-px me-8 bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
                                                        >
                                                            <Icon icon="lucide:edit" />
                                                        </Link>
                                                        <Link onClick={() => handleDeleteClick(farm._id, farm.user_id)} className="w-32-px h-32-px me-8 bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center">
                                                            <Icon icon="mingcute:delete-2-line" />
                                                        </Link>
                                                    </td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div
                            className="tab-pane fade"
                            id="pills-recent-leads"
                            role="tabpanel"
                            aria-labelledby="pills-recent-leads-tab"
                            tabIndex={0}
                        >
                            <div className="table-responsive scroll-sm">
                                <table className="table bordered-table sm-table mb-0">
                                    <thead>
                                        <tr>
                                            <th scope="col">Images</th>
                                            <th scope="col">Name</th>
                                            <th scope="col">Phone Number</th>
                                            {/* <th scope="col">Email Address</th> */}
                                            <th scope="col">City</th>
                                            <th scope="col">Country</th>
                                            <th scope="col">Date</th>
                                            <th scope="col">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {latestwholesaler.map((wholesaler) => (
                                            <tr key={wholesaler._id}>
                                                <td>
                                                    <img
                                                        src={wholesaler.image}
                                                        alt={wholesaler.name}
                                                        className="rounded-circle"
                                                        width="50"
                                                        height="50"
                                                    />
                                                </td>
                                                <td>
                                                    {wholesaler.name || 'No Name Available'}
                                                </td>
                                                <td>{wholesaler.phoneNumber || 'No PhoneNumber Available'}</td>
                                                {/* <td>{wholesaler.email}</td> */}
                                                <td>{wholesaler.city || 'No City Available'}</td>
                                                <td>{wholesaler.country || 'No Country Available'}</td>
                                                <td>{wholesaler.createdAt ? new Date(wholesaler.createdAt).toLocaleDateString() : 'No date available' || 'No Country Available'}</td>
                                                <td>
                                                    <Link
                                                        to={`/wholesaler/details/${wholesaler._id}`}
                                                        className="w-32-px h-32-px me-8 bg-primary-light text-primary-600 rounded-circle d-inline-flex align-items-center justify-content-center"
                                                    >
                                                        <Icon icon="iconamoon:eye-light" />
                                                    </Link>
                                                    {/* <Link
                                                        to={`/wholesaler/edit/${wholesaler._id}`}
                                                        // onClick={() => localStorage.setItem("selectedFarmerId", farm._id)}
                                                        className="w-32-px h-32-px me-8 bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
                                                    >
                                                        <Icon icon="lucide:edit" />
                                                    </Link> */}
                                                    <Link
                                                        onClick={() => handleDeletewholesalerClick(wholesaler._id)}
                                                        className="w-32-px h-32-px me-8 bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center">
                                                        <Icon icon="mingcute:delete-2-line" />
                                                    </Link>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LatestRegisteredOne